import Repository from './repository';

const resource = '/template/email/internal';
export default {
	get() {
		return Repository.getWithAuth(`${resource}`);
	},
	add(payload) {
		return Repository.postWithAuth(
			`${resource}`,
			payload,
			{},
			{ noCache: true }
		);
	},
	update(payload) {
		return Repository.putWithAuth(`${resource}`, payload);
	},
	delete(id) {
		return Repository.deleteWithAuth(`${resource}/${id}`, payload);
	},
};
